// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"0927f51b","94":"b40e3df7","120":"9ec7ecb9","126":"b44e09be","171":"88d70f8a","407":"98af2b26","432":"75d8f630","532":"179dcb13","674":"fcb904e7","684":"67949e04","711":"d0a82325","744":"da79c933","994":"4ef6083c"}[chunkId] + ".chunk.js";
};